import type { RequestBody } from "@src/packages/openapi/helpers";
import type { paths } from "@src/packages/openapi/schema";

type BaseUpdatePatientPayload = RequestBody<
  paths["/{tenantId}/patients/{patientId}"]["patch"]
>;

export type UpdatePatientPayload = BaseUpdatePatientPayload & {
  /** Input-only event emitted after the About You medical-history flow saves. */
  basicInfoCompleted?: true;
  emergencyContactName?: string | null;
  emergencyContactPhone?: string | null;
  emergencyContactRelationship?: string | null;
};

export type UpdatePatientInput = UpdatePatientPayload & {
  /** UUID replay key for the deployed durable legacy patient PATCH contract. */
  _idempotencyKey?: string;
  _signal?: AbortSignal;
};

export function prepareUpdatePatientInput(input: UpdatePatientInput) {
  const { _idempotencyKey, _signal, ...data } = input;
  return {
    data,
    idempotencyKey: _idempotencyKey,
    signal: _signal,
  };
}

export function buildUpdatePatientPatchOptions({
  tenantId,
  patientId,
  data,
  idempotencyKey,
  signal,
}: {
  tenantId: string;
  patientId: string;
  data: UpdatePatientPayload;
  idempotencyKey?: string;
  signal?: AbortSignal;
}) {
  return {
    params: {
      path: {
        tenantId,
        patientId,
      },
      header: {
        "x-api-version": "2026-06-17" as const,
        ...(idempotencyKey ? { "Idempotency-Key": idempotencyKey } : {}),
      },
    },
    body: data,
    signal,
  };
}
